/**
 * @generated SignedSource<<573382071002c51130f1e44c1d9b740d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClientContactDropdown_clientContacts$data = ReadonlyArray<{
  readonly node: {
    readonly id: string;
    readonly firstName: string | null;
    readonly lastName: string | null;
    readonly client: {
      readonly id: string;
      readonly name: string;
    } | null;
  } | null;
  readonly " $fragmentType": "ClientContactDropdown_clientContacts";
}>;
export type ClientContactDropdown_clientContacts$key = ReadonlyArray<{
  readonly " $data"?: ClientContactDropdown_clientContacts$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClientContactDropdown_clientContacts">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ClientContactDropdown_clientContacts",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientContact",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Client",
          "kind": "LinkedField",
          "name": "client",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ClientContactEdge",
  "abstractKey": null
};
})();

(node as any).hash = "b4fd21ac1e5c803c278778b5fab1a765";

export default node;
